module.exports = __webpack_public_path__ + "img/preach.d2519b91.png";